<template>
  <div class="container">
    <group />
  </div>
</template>

<script>
import group from './group.vue'
export default {
  components: { group },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
